import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default new Vuex.Store({
    state: {
        // 自动定位城市 id name
        geoCity: null,
        // 本次选择城市
        city: null,
        // 城市列表
        cityList: [],
        // 弹框隐藏后 项目内各页面返回 不再次弹框
        // flag: false,
        // h5 多次点城市 领券页返回按钮只有一次历史记录
        oneFlag:false,
        downloadInfo: {
            logo: 'https://images.daojia.com/jz/pic/97e3b19805fee9f57e4bed2b8dd76d64.png',
            content: '天鹅到家，悠享生活之美',
            url: window.downloadUrl,
            flag: false
        },
        downloadFlag: false
    },
    mutations: {
        setGeoCity: (state, name) => state.geoCity = name,
        setCity: (state, name) => state.city = name,
        setPhone: (state, phone) => state.phone = phone,
        setToken: (state, token) => state.token = token,
        setCityList: (state, list) => state.cityList = list, 
        // setFlag: state => state.flag = true,
        setOneFlag: state => state.oneFlag = true,
        resetOneFlag: state => state.oneFlag = false,
        setDownloadInfo: (state, data)  => {
            state.downloadInfo = data
            console.log('daata'+JSON.stringify(data))
        },
        setDownloadFlag: (state, data)  => state.downloadFlag = data,
        setDownloadUrl: (state, data)  => state.downloadInfo.url = data
    },
    actions: {
        geoCity: ({
            commit
        }, name) => {
            commit('setGeoCity', name)
        },
        city: ({
            commit
        }, name) => {
            commit('setCity', name)
        },
        cityList: ({
            commit
        }, payLoad) => {
            Vue.http.jsonp(window.cityUrl, {
                params: {
                    'activityid': payLoad.activityid,
                    'templateid': payLoad.templateid
                }
            }).then(function(res) {
                var data = Object.assign({}, res.json())
                if (data.code == 0) {
                    if (data.data && data.data.citys && data.data.citys.length) {
                        commit('setCityList', data.data.citys)
                    }
                }
            })
        },
        // flag: ({
        //     commit
        // }) => commit('setFlag'),
        setOneFlag: ({
            commit
        }) => commit('setOneFlag'),
        resetOneFlag: ({
            commit
        }) => commit('resetOneFlag'),
        setDownloadInfo: ({
            commit
        }, data) => commit('setDownloadInfo', data),
        setDownloadFlag: ({
            commit
        }, data) => commit('setDownloadFlag', data),
        setDownloadUrl: ({
            commit
        }, data) => commit('setDownloadUrl', data)
    },
    getters: {
        getGeoCity: state => state.geoCity,
        getCity: state => state.city,
        getCityList: state => state.cityList,
        // getFlag: state => state.flag,
        getOneFlag: state => state.oneFlag,
        getDownloadInfo: state => state.downloadInfo,
        getDownloadFlag: state => state.downloadFlag,
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js